///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActionsToolbarModeEnum } from '../../../../../generated/shared-types.model';

export class GtthToolbarModeChangedCommand extends GtthAbstractCommand {
    private toolbarMode: ActionsToolbarModeEnum;

    getCommandName(): string {
        return 'GtthToolbarModeChangedCommand';
    }

    create(toolbarMode: ActionsToolbarModeEnum): this {
        this.toolbarMode = toolbarMode;
        return this;
    }

    doCommand(): void {
        // before mode changed
        if (this.historyService.logicalTopology) {
            this.beforeModeChanged(this.historyService.toolbarMode, this.toolbarMode);
        }

        const oldValue = this.historyService.toolbarMode;
        this.historyService.toolbarMode = this.toolbarMode;
        this.historyService.projectUserSessionService.setActionMode(this.toolbarMode);

        // after mode changed
        if (this.historyService.logicalTopology) {
            this.afterModeChanged(oldValue, this.toolbarMode);
        }
        // return false as this command will not be stored in history
        this.commandResolve(false);
    }

    private beforeModeChanged(_oldValue: ActionsToolbarModeEnum, _newValue: ActionsToolbarModeEnum) {
        this.historyService.logicalTopology.clearSelection();
    }

    private afterModeChanged(_oldValue: ActionsToolbarModeEnum, newValue: ActionsToolbarModeEnum) {
        if (newValue === ActionsToolbarModeEnum.SELECT_AREA_MODE) {
            this.historyService.selectAreaService.initDrawSquareListeners();
        } else {
            this.historyService.selectAreaService.destroyListeners();
        }

        this.historyService.eventManager.broadcast({
            name: 'actionModeChanged',
            content: newValue
        });
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
